<template>
  <section v-on:click="headerClicked">
    <header v-on:mouseleave="liLeaveHeader">
      <div class="logoCnt">
        <div class="logo">
          <a :href="`${$config.appPath}${langCode}`">
            <img :src="logo.imageMd" v-if="logo"/>
          </a>
        </div>
      </div>
      <div class="menuWrapper">
        <div class="menuCnt loading" v-if="loadingMenu"></div>
        <div class="menuCnt" :class="{open: menuOpen}" v-else>
          <li v-for="(m, i) in menu" :key="`m${i}`"
            :class="{hasDd: m.submenus && m.submenus.length > 0,
            hidden: m.status === 'unpublished', submenuOpen: m.submenuOpen}">
            <div class="menuItem" v-if="m.type === 'Unclickable'"
              v-on:click.stop="toggleSubmenu(m)"
              v-on:mouseover="liHover(m)">
              {{m.name[lang]}}
              <div class="ddIcon"></div>
            </div>
            <a :href="m.link" class="menuItem green" v-else-if="m.type === 'External Link'"
              v-on:click.prevent="openMenuItem($event, m)"
              v-on:mouseover="liHover(m)" target="_blank">
              {{m.name[lang]}}
              <div class="ddIcon"></div>
            </a>
            <a :href="`${$config.appPath}${langCode}${m.uri}`" class="menuItem" v-else
              v-on:click.prevent="openMenuItem($event, m)"
              v-on:mouseover="liHover(m)">
              {{m.name[lang]}}
              <div class="ddIcon" v-on:click.stop="toggleSubmenu(m)"></div>
            </a>
            <div class="menuDd" v-if="m.submenus && m.submenus.length > 0"
              v-on:mouseleave="liLeave(m)">
              <div class="submenu" v-for="(sm, i2) in m.submenus" :key="`sm${i2}`"
                :class="{hidden: sm.status === 'unpublished'}">
                <div class="submenuTitle">{{sm.title[lang]}}</div>
                <div class="submenuItemWrapper" v-for="(smm, i) in sm.menus" :key="`hmn${i}`">
                  <div class="submenuItem" v-if="smm.type === 'Unclickable'"
                    :class="{hidden: smm.status === 'unpublished'}">{{smm.name[lang]}}</div>
                  <a class="submenuItem" :href="smm.uri" v-else-if="smm.type === 'External Link'"
                    :class="{hidden: smm.status === 'unpublished'}"
                    v-on:click.prevent="openMenuItem($event, smm)">
                    {{smm.name[lang]}}</a>
                  <a class="submenuItem" v-else
                    :href="`${$config.appPath}${langCode}${smm.uri}`"
                    :class="{hidden: smm.status === 'unpublished'}"
                    v-on:click.prevent="openMenuItem($event, smm)">
                    {{smm.name[lang]}}</a>
                  <div class="submenuDd" v-if="smm.submenus && smm.submenus.length > 0"
                    :class="{hidden: smm.status === 'unpublished'}">
                    <div class="submenu" v-for="(sm3, i3) in smm.submenus" :key="`sm${i3}`"
                      :class="{hidden: sm3.status === 'unpublished'}">
                      <div class="submenuTitle">{{sm3.title[lang]}}</div>
                      <div class="submenuItemWrapper"
                        v-for="(smm3, i3a) in sm3.menus" :key="`hmn${i3a}`">
                        <div class="submenuItem" v-if="smm3.type === 'Unclickable'"
                          :class="{hidden: smm3.status === 'unpublished'}">{{smm3.name[lang]}}</div>
                        <a class="submenuItem" :href="smm3.uri"
                          v-else-if="smm3.type === 'External Link'"
                          :class="{hidden: smm3.status === 'unpublished'}"
                          v-on:click.prevent="openMenuItem($event, smm3)">
                          {{smm3.name[lang]}}</a>
                        <a class="submenuItem" v-else
                          :href="`${$config.appPath}${langCode}${smm3.uri}`"
                          :class="{hidden: smm3.status === 'unpublished'}"
                          v-on:click.prevent="openMenuItem($event, smm3)">
                          {{smm3.name[lang]}}</a>
                        <div class="submenuDd" v-if="smm3.submenus && smm3.submenus.length > 0"
                          :class="{hidden: smm3.status === 'unpublished'}">
                          <div class="submenu" v-for="(sm4, i4) in smm3.submenus" :key="`sm${i4}`"
                            :class="{hidden: sm4.status === 'unpublished'}">
                            <div class="submenuTitle">{{sm4.title[lang]}}</div>
                            <div class="submenuItemWrapper"
                              v-for="(smm4, i4a) in sm4.menus" :key="`hmn${i4a}`">
                              <div class="submenuItem" v-if="smm4.type === 'Unclickable'"
                                :class="{hidden: smm4.status === 'unpublished'}">{{smm4.name[lang]}}</div>
                              <a class="submenuItem" :href="smm4.uri"
                                v-else-if="smm4.type === 'External Link'"
                                :class="{hidden: smm4.status === 'unpublished'}"
                                v-on:click.prevent="openMenuItem($event, smm4)">
                                {{smm4.name[lang]}}</a>
                              <a class="submenuItem" v-else
                                :href="`${$config.appPath}${langCode}${smm4.uri}`"
                                :class="{hidden: smm4.status === 'unpublished'}"
                                v-on:click.prevent="openMenuItem($event, smm4)">
                                {{smm4.name[lang]}}</a>
                              <div class="submenuDd" v-if="smm4.submenus && smm4.submenus.length > 0"
                                :class="{hidden: smm4.status === 'unpublished'}">
                                <div class="submenu" v-for="(sm5, i5) in smm4.submenus"
                                  :key="`sm${i5}`"
                                  :class="{hidden: sm5.status === 'unpublished'}">
                                  <div class="submenuTitle">{{sm5.title[lang]}}</div>
                                  <div class="submenuItemWrapper"
                                    v-for="(smm5, i5a) in sm5.menus" :key="`hmn${i5a}`">
                                    <div class="submenuItem" v-if="smm5.type === 'Unclickable'"
                                      :class="{hidden: smm5.status === 'unpublished'}">{{smm5.name[lang]}}</div>
                                    <a class="submenuItem" :href="smm5.uri"
                                      v-else-if="smm5.type === 'External Link'"
                                      :class="{hidden: smm5.status === 'unpublished'}"
                                      v-on:click.prevent="openMenuItem($event, smm5)">
                                      {{smm5.name[lang]}}</a>
                                    <a class="submenuItem" v-else
                                      :href="`${$config.appPath}${langCode}${smm5.uri}`"
                                      :class="{hidden: smm5.status === 'unpublished'}"
                                      v-on:click.prevent="openMenuItem($event, smm5)">
                                      {{smm5.name[lang]}}</a>
                                    <div class="submenuDd" v-if="smm5.submenus && smm5.submenus.length > 0"
                                      :class="{hidden: smm5.status === 'unpublished'}">
                                      <div class="submenu" v-for="(sm6, i6) in smm5.submenus"
                                        :key="`sm${i6}`"
                                        :class="{hidden: sm6.status === 'unpublished'}">
                                        <div class="submenuTitle">{{sm6.title[lang]}}</div>
                                        <div class="submenuItemWrapper"
                                          v-for="(smm6, i6a) in sm6.menus" :key="`hmn${i6a}`">
                                          <div class="submenuItem" v-if="smm6.type === 'Unclickable'"
                                            :class="{hidden: smm6.status === 'unpublished'}">{{smm6.name[lang]}}</div>
                                          <a class="submenuItem" :href="smm6.uri"
                                            v-else-if="smm6.type === 'External Link'"
                                            :class="{hidden: smm6.status === 'unpublished'}"
                                            v-on:click.prevent="openMenuItem($event, smm6)">
                                            {{smm6.name[lang]}}</a>
                                          <a class="submenuItem" v-else
                                            :href="`${$config.appPath}${langCode}${smm6.uri}`"
                                            :class="{hidden: smm6.status === 'unpublished'}"
                                            v-on:click.prevent="openMenuItem($event, smm6)">
                                            {{smm6.name[lang]}}</a>
                                          <div class="submenuDd" v-if="smm6.submenus && smm6.submenus.length > 0"
                                            :class="{hidden: smm6.status === 'unpublished'}">
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </div>
        <div class="menuToggle" v-on:click.stop="toggleMenu"></div>
      </div>
      <div class="searchCnt" v-on:click.stop="doNothing"
        :class="{searchOpenLg: searchOpenLg}">
        <form v-on:submit.prevent="gotoSearch" action="/search"
          :class="{searchLoading: searchLoading}">
          <input type="text" placeholder="Pencarian..."
            name="q" autocomplete="off" spellcheck="off" v-model="q"
            ref="search" v-on:input="search" v-on:focus="searchFocused"
            v-on:click.stop="doNothing">
          <div class="searchLoading"></div>
          <div class="closeSearch" v-on:click.stop="searchOpen = false"></div>
          <button type="submit"></button>
        </form>
        <div class="searchOverlay" v-if="viewSearchDd"></div>
        <perfect-scrollbar class="searchDd" v-if="viewSearchDd && searchOpenLg">
          <div class="searchLoading" v-if="searchLoading"></div>
          <div class="notFound" v-else-if="searchResults.length < 1">
            <h4 v-if="lang === 'id'">Tidak ada hasil ditemukan</h4>
            <h4 v-if="lang === 'en'">No result found</h4>
            <p v-if="lang === 'id'">
              Apa yang kamu cari sepertinya tidak ada,
              coba ganti kata kunci pencarian.
            </p>
            <p v-if="lang === 'en'">
              What you are looking for doesn't seem to exist,
              try changing the search keywords.
            </p>
          </div>
          <div v-else>
            <li><a :href="`${$config.appPath}${langCode}/search?q=${q}`">
              <div class="icon search"></div><div class="label">{{q}}</div></a></li>
            <li v-for="(item, i) in searchResults" :key="i"
              v-on:click.stop="selectSearch(item)">
              <a :href="`${$config.appPath}${langCode}${item.uri}`" :class="item.type">
                <div class="icon menu" v-if="item.type === 'menu'"></div>
                <template v-else>
                  <div class="icon" :style="{'background-image': `url(${item.thumb[lang]})`}"
                    v-if="item.thumb && item.thumb[lang]"></div>
                  <div class="icon noImg" v-else></div>
                </template>
                <div class="label">{{item.label[lang]}}</div>
                <div class="type" v-if="item.type === 'menu'">Menu</div>
              </a>
            </li>
            <li class="more"><a :href="`${$config.appPath}${langCode}/search?q=${q}`">
              <div class="icon search"></div>
              <div class="label" v-if="lang === 'en'">View more result</div>
              <div class="label" v-if="lang === 'id'">Lihat hasil lebih banyak</div>
            </a></li>
          </div>
        </perfect-scrollbar>
      </div>
    </header>
    <Confirmation ref="confirmDialog"/>
    <LoadingDialog ref="loadingDialog"/>
  </section>
</template>

<script>
import Confirmation from '@/components/Confirmation.vue';
import LoadingDialog from '@/components/LoadingDialog.vue';

const nanoid = require('nanoid');

export default {
  components: { Confirmation, LoadingDialog },
  props: ['merchandise', 'donation'],
  data() {
    return {
      menuOpen: false,
      scrolled: false,
      showMenu: false,
      newsCategory: [],
      logo: null,

      /**
       * User
       *
       */
      user: { avatar: '', name: '', email: '' },
      loggedIn: false,
      userMenuOpen: false,

      /**
       * Menu
       *
       */
      menu: [],
      loadingMenu: true,

      /**
       * Search
       *
       */
      searchOpen: false,
      searchOpenLg: false,
      viewSearchDd: false,
      q: '',
      searchLoading: false,
      searchTimer: null,

      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  methods: {
    doNothing() {},
    openMenuItem(e, m) {
      let session = localStorage.getItem('icel_ua_session');
      if (!session) {
        session = nanoid.nanoid(64);
        localStorage.setItem('icel_ua_session', session);
      }
      this.$http.get(this.$config.uri(`config/menu/${m.code}/analytic?session=${session}`));
      setTimeout(() => {
        if (m.type === 'External Link') {
          window.open(e.target.href, '_blank').focus();
        } else {
          window.location.href = e.target.href;
        }
      });
    },
    liHover(item) {
      // eslint-disable-next-line
      for (const m of this.menu) {
        m.submenuOpen = false;
      }
      item.submenuOpen = true;
    },
    liLeave(item) {
      item.submenuOpen = false;
    },
    liLeaveHeader() {
      // eslint-disable-next-line
      for (const m of this.menu) {
        m.submenuOpen = false;
      }
    },
    headerClicked() {
      this.searchOpenLg = false;
      this.viewSearchDd = false;
      document.getElementsByTagName('BODY')[0].classList.remove('stopscroll');
      if (this.menuOpen) this.toggleMenu();
    },
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
      if (this.menuOpen) {
        document.getElementsByTagName('BODY')[0].classList.add('stopscroll');
      } else {
        document.getElementsByTagName('BODY')[0].classList.remove('stopscroll');
      }
    },
    toggleSubmenu(menu) {
      // eslint-disable-next-line
      for (const m of this.menu) {
        m.submenuOpen = false;
      }
      menu.submenuOpen = !menu.submenuOpen;
    },
    selectSearch(item) {
      if (item.title && (!item.url || item.url === '')) return;
      if (item.title) {
        window.open(item.url, '_blank').focus();
      } else {
        // this.$router.push('/team-up-everyday');
      }
    },
    openSearch() {
      this.searchOpen = true;
      setTimeout(() => {
        this.$refs.search.focus();
      }, 300);
    },
    searchFocused() {
      this.searchOpenLg = true;
      this.search();
    },
    gotoSearch() {
      if (this.$refs.search) this.$refs.search.focus();
      if (!this.q || this.q === '') return;
      window.location.href = `${this.$config.appPath}${this.langCode}/search?q=${this.q}`;
    },
    search() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        if (!this.q || this.q === '') {
          this.searchLoading = false;
          this.viewSearchDd = false;
          document.getElementsByTagName('BODY')[0].classList.remove('stopscroll');
          return;
        }
        this.searchLoading = true;
        this.$http.post(this.$config.uri('misc/search'), {
          q: this.q,
          lang: this.lang,
        }).then((r) => {
          this.searchResults = (r.data.status === 200) ? r.data.data : [];
          this.searchLoading = false;
          this.viewSearchDd = true;
          document.getElementsByTagName('BODY')[0].classList.add('stopscroll');
        });
      }, 500);
    },
    openLogin() { this.$refs.loginModal.open(); },
    signOut() {
      this.showMenu = false;
      this.$refs.confirmDialog.open({
        title: 'Keluar',
        desc: 'Apakah kamu yakin ingin keluar? kamu dapat masuk kembali kapan aja.',
        action: 'Keluar',
      }, (b) => {
        if (!b) return;
        this.$session.destroy();
        window.location.reload();
      });
    },
  },
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';

    this.$http.get(this.$config.uri('config/item/logo?media=y')).then((r) => {
      this.logo = (r.data.status === 200) ? r.data.data : null;
    });

    this.$http.get(this.$config.uri('config/menu')).then((r) => {
      this.loadingMenu = false;
      this.menu = (r.data.status === 200) ? r.data.data : [];
    });

    if (this.$route.name === 'search') this.q = this.$route.query.q;
  },
};
</script>

<style scoped lang="scss">
header{
  position: fixed;
  left: 0; right: 0; top: 0;
  z-index: 99;
  color: #fff;
  display: flex;
  align-items: stretch;
  background-color: #333;
  height: 74px;
  box-sizing: border-box;
  transition: all .3s ease;
  @media (max-width: 1480px) {
    height: 64px;
  }
  .menuToggle{
    width: 40px; height: 40px;
    border-radius: 50%;
    margin-right: 26px;
    background-image: url(../assets/menu-lighter-white.png);
    background-size: 26px auto;
    background-position: center;
    background-repeat: no-repeat;
    opacity: 1;
    cursor: pointer;
    transition: all .3s ease;
    display: none;
    @media (max-width: 1080px) {
      display: block;
    }
    &:hover{
      opacity: 1;
    }
  }
  .menuWrapper{
    display: flex;
    align-items: center;
    @media (max-width: 680px) {
      padding-right: 60px;
    }
  }
  .menuCnt{
    display: flex;
    height: 100%;
    &.loading{
      background-color: rgba(0, 0, 0, .1);
      height: 20px;
      border-radius: 50px;
      width: 240px;
      margin-right: 20px;
    }
    @media (max-width: 1080px) {
      position: fixed;
      top: 64px; right: 0; left: 0;
      background-color: #333;
      border-top: #444 1px solid;
      border-radius: 0;
      height: auto;
      z-index: 7;
      box-sizing: border-box;
      transition: all .3s ease;
      box-shadow: 0 2px 6px rgba(0, 0, 0, .2);
      visibility: hidden;
      display: block;
      opacity: 0;
      transform: translateY(10px);
    }
    &.open{
      @media (max-width: 1080px) {
        visibility: visible;
        opacity: 1;
        transform: none;
      }
    }
    li{
      list-style: none;
      position: relative;
      height: 100%;
      @media (max-width: 1080px) {
        height: auto;
      }
      .menuDd{
        position: fixed;
        left: 0; top: 74px; right: 0;
        background-color: #fff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .1);
        visibility: hidden;
        display: flex;
        flex-wrap: wrap;
        transition: all .3s ease;
        transform: translateY(10px);
        opacity: 0;
        @media (max-width: 1480px) {
          top: 64px;
        }
        @media (max-width: 1080px) {
          position: static;
          background-color: #fff;
          transform: none;
          opacity: 1;
          visibility: visible;
          display: none;
          overflow: auto;
          max-height: 300px;
          padding: 6px 0;
        }
        @media (max-width: 840px) {
          display: none;
        }
        .submenu{
          width: 33.333333%;
          padding: 30px 16px;
          box-sizing: border-box;
          max-height: calc(100vh - 74px);
          overflow: auto;
          @media (max-width: 1480px) {
            max-height: calc(100vh - 64px);
          }
          @media (max-width: 1080px) {
            width: 50%;
            padding: 20px 10px;
          }
          @media (max-width: 840px) {
            width: auto;
            padding: 16px 0;
          }
          &.hidden{
            display: none;
          }
          .submenuDd{
            background-color: rgba(0, 0, 0, .05);
            display: block;
            border-radius: 7px;
            &.hidden{
              display: none;
            }
            .submenu{
              width: auto;
              padding: 20px 10px 10px;
            }
          }
          .submenuTitle{
            color: #444;
            font-size: 16px;
            font-weight: 600;
            padding: 0 16px 20px;
            text-transform: uppercase;
            text-transform: uppercase;
            @media (max-width: 1080px) {
              font-size: 14px;
            }
            @media (max-width: 840px) {
              padding: 0 20px 10px;
            }
          }
          .submenuItem{
            padding: 12px 16px;
            margin: 0 0 6px;
            // border-bottom: #eee 1px solid;
            // white-space: nowrap;
            color: #444;
            display: block;
            font-size: 14px;
            cursor: pointer;
            border-radius: 5px;
            transition: all .3s ease;
            @media (max-width: 840px) {
              padding: 10px 20px;
            }
            &.hidden{
              display: none;
            }
            &:hover{
              background-color: #eee;
            }
          }
        }
      }
      &:hover{
        // .menuDd{
        //   visibility: visible;
        //   transform: none;
        //   opacity: 1;
        // }
      }
      &.submenuOpen{
        .menuDd{
          visibility: visible;
          transform: none;
          opacity: 1;
        }
        .menuItem{
          @media (max-width: 1080px) {
            background-color: #111;
          }
          .ddIcon{
            @media (max-width: 1080px) {
              background-color: #fff;
              background-image: url(../assets/down-arrow-black.png) !important;
            }
          }
        }
        .menuDd{
          @media (max-width: 1080px) {
            display: flex;
          }
          @media (max-width: 840px) {
            display: block;
          }
        }
      }
      .menuItem{
        padding: 0 20px;
        transition: all .3s ease;
        font-size: 15px;
        white-space: nowrap;
        cursor: pointer;
        color: #fff;
        height: 100%;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        @media (max-width: 1480px) {
          font-size: 13px;
          padding: 0 14px;
        }
        @media (max-width: 1080px) {
          font-size: 14px;
          padding: 12px 20px;
        }
        &.green{
          background-color: #008552;
          &:hover{
            background-color: #006a42;
          }
        }
        &:hover{
          background-color: #111;
        }
      }
      &.hasDd{
        .menuItem{
          padding-right: 36px;
          .ddIcon{
            position: absolute;
            right: 10px; top: 0; bottom: 0; width: 20px;
            background-image: url(../assets/down-arrow-white.png);
            background-size: 8px auto;
            background-position: center;
            background-repeat: no-repeat;
            @media (max-width: 1080px) {
              bottom: auto;
              width: 64px; right: 0;
              height: 46px;
            }
          }
        }
      }
      &.hidden{
        display: none;
      }
    }
  }
  .logoCnt{
    display: flex;
    overflow: hidden;
    margin-right: auto;
    .uncorupted{
      padding-left: 20px;
      display: flex;
      align-items: center;
      margin-left: 6px;
      .theX{
        position: relative;
        height: 100%;
        width: 46px;
        .xItem{
          position: absolute;
          width: 1px; height: 47px;
          &.x1{
            transform: rotate(-30deg);
            left: 0; top: -6px;
            background-color: #222;
          }
          &.x2{
            transform: rotate(30deg);
            left: 24px; top: -6px;
            background-color: #ccc;
            display: none;
          }
          &.x3{
            transform: rotate(30deg);
            left: 0; bottom: -6px;
            background-color: #222;
          }
          &.x4{
            transform: rotate(-30deg);
            left: 24px; bottom: -6px;
            background-color: #ccc;
            display: none;
          }
        }
      }
      img{
        height: 58px;
      }
    }
    .logo{
      font-size: 26px;
      font-weight: bold;
      display: flex;
      position: relative;
      z-index: 3;
      margin-left: 120px;
      @media (max-width: 1480px) {
        margin-left: 80px;
      }
      @media (max-width: 1240px) {
        margin-left: 40px;
      }
      @media (max-width: 680px) {
        margin-left: 16px;
      }
      a{
        white-space: nowrap;
        display: flex;
        align-items: center;
      }
      img{
        height: 50px;
        @media (max-width: 1240px) {
          height: 46px;
        }
        @media (max-width: 680px) {
          height: 42px;
        }
      }
      span{
        display: block;
        padding-left: 16px;
        margin-top: 4px;
        overflow: hidden;
        text-overflow: ellipsis;
        font-weight: 400;
        @media (max-width: 760px) {
          display: none;
        }
      }
      @media (max-width: 760px) {
      }
    }
  }
  .searchCnt{
    border-radius: 50px;
    z-index: 17;
    width: 200px;
    position: relative;
    transition: all .3s ease;
    &:hover{
      width: 240px;
    }
    @media (max-width: 680px) {
      position: absolute;
      right: 0; top: 0; bottom: 0;
      width: 64px !important;
    }
    &.searchOpenLg{
      width: 400px;
      @media (max-width: 680px) {
        width: 100% !important;
      }
    }
    .searchDd{
      background-color: #fff;
      position: absolute;
      top: 100%; right: 0; left: 0;
      border-radius: 0 0 7px 7px;
      box-shadow: 2px 2px 6px rgba(0,0,0,.2);
      // margin-top: 2px;
      padding: 10px 0;
      font-size: 17px;
      z-index: 2;
      max-height: 400px;
      .searchLoading{
        height: 160px;
        background-image: url(../assets/loading.svg);
        background-size: 40px auto;
        background-position: center;
        background-repeat: no-repeat;
      }
      .notFound{
        color: #444;
        padding: 20px 20px;
        position: static;
        transform: none;
        h4{
          margin: 0 0 2px;
          font-weight: 500;
          font-size: 18px;
        }
        p{
          margin: 0;
          font-size: 14px;
          line-height: 1.4;
          color: #767676;
        }
      }
      li{
        list-style: none;
        cursor: pointer;
        position: relative;
        box-sizing: border-box;
        &.more{
          border-top: #eee 1px solid;
          margin-top: 10px;
        }
        a{
          display: block;
          padding: 10px 40px;
          position: relative;
          padding-left: 64px;
          box-sizing: border-box;
          line-height: 1.4;
          &.article{
            padding-top: 12px;
            padding-bottom: 12px;
          }
        }
        .label{
          font-size: 15px;
          font-weight: 500;
          color: #444;
          overflow: hidden;
          line-height: 1.4;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .type{
          color: #767676;
          font-size: 14px;
        }
        .icon{
          position: absolute;
          left: 18px; top: 50%;
          margin-top: -15px;
          width: 30px; height: 30px;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          border-radius: 3px;
          // background-color: #eee;
          &.search{
            background-image: url(../assets/search.png);
            background-size: 16px auto;
          }
          &.menu{
            background-image: url(../assets/menu-lighter.png);
            background-size: 16px auto;
          }
          &.noImg{
            background-color: #eee;
            &:before{
              position: absolute;
              content: "";
              left: 0; right: 0; top: 0; bottom: 0;
              background-size: 16px auto;
              background-position: center;
              background-repeat: no-repeat;
              background-image: url(../assets/icel-logo-grey.png);
              opacity: .56;
              &.audio{
                background-image: url(../assets/musical-note-blue.svg);
                background-color: #e3eaff;
                opacity: 1;
              }
            }
          }
        }
        &:hover{
          background-color: #f5f5fe;
        }
        &.category{
          padding-left: 50px;
          .icon{
            background-image: url(../assets/empty-folder.svg);
            width: 20px; height: 20px;
            top: 9px; left: 20px;
          }
        }
        &.header{
          text-transform: uppercase;
          color: #888;
          font-weight: 500;
          font-size: 12px;
          padding: 16px 20px 6px;
          cursor: default;
          &:hover{
            background-color: #fff;
          }
          .icon{
            display: none;
          }
        }
      }
      @media (max-width: 760px) {
      }
    }
    form{
      position: relative;
      height: 100%;
      .searchLoading{
        position: absolute;
        width: 30px; height: 30px;
        border: none; border-radius: 50%;
        top: 5px; right: 10px;
        background-image: url(../assets/loading.svg);
        background-size: 22px auto;
        background-position: center;
        background-repeat: no-repeat;
        display: none;
      }
      &.searchLoading{
        button{
          display: none;
        }
        .searchLoading{
          display: block;
        }
      }
      input{
        border: #444 2px solid;
        background-color: #444;
        box-shadow: none;
        border-radius: 0;
        text-overflow: ellipsis;
        font-size: 16px;
        outline: 0 !important;
        width: 100%;
        color: #fff;
        box-sizing: border-box;
        transition: all .3s ease;
        padding: 0 20px;
        height: 100%;
        padding-right: 48px;
        &:hover{
          background-color: #555;
          border-color: #555;
        }
        &:focus{
          border-color: #555;
          background-color: #555;
        }
      }
      .closeSearch{
        position: absolute;
        width: 44px; height: 44px;
        border: none; border-radius: 50%;
        top: 0; right: 2px;
        outline: 0;
        background-color: transparent;
        background-image: url(../assets/close.png);
        background-size: 12px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .6;
        display: none;
      }
      button{
        position: absolute;
        width: 40px; height: 40px;
        border: none; border-radius: 50%;
        top: 50%; right: 16px;
        margin-top: -20px;
        padding: 0; outline: 0;
        background-color: transparent;
        background-image: url(../assets/search-white.png);
        background-size: 20px auto;
        background-position: center;
        background-repeat: no-repeat;
        box-sizing: border-box;
        box-shadow: none;
        cursor: pointer;
        transition: all .3s ease;
        @media (max-width: 680px) {
          right: 7px; width: 46px; height: 46px;
          margin-top: -22px;
        }
        &:hover{
          background-color: rgba(0, 0, 0, .2);
        }
      }
    }
    .close{
      display: none;
    }
    &.open{
      .searchDd{
        display: block;
      }
      @media (max-width: 860px) {
        width: 420px;
      }
      @media (max-width: 740px) {
        width: auto;
        left: 16px; right: 16px; top: 8px;
        button{
          display: none;
        }
        .closeSearch{
          display: block;
        }
      }
      form{
        input{
          display: block;
        }
      }
    }
  }
}
.scrolled header{
  height: 60px;
  .menuCnt{
    @media (max-width: 1080px) {
      top: 60px;
    }
    li{
      .menuDd{
        top: 60px;
      }
    }
  }
}
</style>
